import styles from './logo.module.css';
import { ReactComponent as LogoSvg } from '../../assets/Logo.svg';
import { toKebabCase } from '../../utils/casing';
import { WithTestId } from '../../types';

export type LogoProps = WithTestId;

const Logo = ({ dataTestIdPrefix }: LogoProps) => (
  <div
    className={styles.logo}
    data-testid={toKebabCase(dataTestIdPrefix, 'logo')}
  >
    <LogoSvg />
  </div>
);

export default Logo;
